import React, { useEffect, useRef, useState } from 'react'
import transition from "../transition";
import {Typewriter, Cursor} from "react-simple-typewriter";
import ProjectSection from './ProjectSection';
import projects from '../projects';
import  MouseImageTrail  from './MouseImageTrail';
import trailImages from '../trailImages';


const About = () => {
  const [active, setActive] = useState(0);
  const barRef = useRef(null);

  // scroll so the project header lands just below the navbar and the button bar
  const jumpTo = (i) => {
    const offset = document.querySelector(".nav").offsetHeight + barRef.current.offsetHeight;
    const top = document.getElementById(`project-${i}`).getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: "smooth" });
  };

  // highlight the button for the project currently in view
  useEffect(() => {
    const onScroll = () => {
      const atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
      let current = atBottom ? projects.length - 1 : 0;
      if (!atBottom) {
        projects.forEach((_, i) => {
          if (document.getElementById(`project-${i}`).getBoundingClientRect().top <= window.innerHeight * 0.4) current = i;
        });
      }
      setActive(current);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div>
      <h1>
        <Typewriter className = "typeWriter" words= {['.joyastick', '.js', 'projects.js']}/><Cursor />
      </h1>

      <MouseImageTrail
      renderImageBuffer={150}
      rotationRange={25}
      images={trailImages}
    >
        <div className ="flex flex-col items-center gap-10 mt-20 mb-44 px-4">
          <div ref={barRef} className="project-bar sticky top-[var(--nav-h)] z-[1500] flex w-fit max-w-full flex-wrap px-8 sm:px-12 justify-center gap-x-5 gap-y-3 py-5 sm:gap-x-8 sm:gap-y-6 sm:py-6">
            {projects.map((p, i) => (
              <button
                key={p.title}
                onClick={() => jumpTo(i)}
                className={`relative flex items-center rounded-full py-1 pr-4 text-sm font-bold shadow-lg transition-transform hover:scale-105 sm:py-2 sm:pr-5 sm:text-base ${p.icon ? "pl-9 sm:pl-14" : "pl-4 sm:pl-5"} ${i === active ? "bg-emerald-900/90 text-emerald-100" : "bg-emerald-100/75"}`}
              >
                {p.icon && (
                  <img
                    src={p.icon}
                    alt=""
                    className="absolute -left-2 top-1/2 h-10 w-10 -translate-y-1/2 object-contain drop-shadow-lg sm:-left-3 sm:h-16 sm:w-16"
                  />
                )}
                {p.title}
              </button>
            ))}
          </div>
          {projects.map((p, i) => (
            <ProjectSection key={p.title} id={`project-${i}`} {...p} />
          ))}
        </div>
    </MouseImageTrail>

    </div>
  )
}

export default transition(About);